import { useEffect } from 'react';

function tipptGerade(e: KeyboardEvent): boolean {
  const z = e.target as HTMLElement | null;
  return !!z && (z.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(z.tagName));
}

/** Tastenkürzel, die nicht greifen, während jemand in ein Feld tippt (außer mit ⌘/Strg) */
export function useTaste(taste: string, fn: (e: KeyboardEvent) => void, { mitBefehl = false } = {}) {
  useEffect(() => {
    const h = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() !== taste) return;
      if (mitBefehl ? !(e.metaKey || e.ctrlKey) : e.metaKey || e.ctrlKey || e.altKey || tipptGerade(e)) return;
      if (document.querySelector('dialog[open]') && !mitBefehl) return;
      e.preventDefault();
      fn(e);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [taste, fn, mitBefehl]);
}

export const istMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
